import React from "react";
import { FormControl } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TimeRegistrationTypeSelect.scss";

/**
 * Selector de tipo de fichaje con aspecto de píldora (nativo select estilizado).
 */
const TimeRegistrationTypeSelect = ({
	id,
	value,
	disabled,
	options,
	onChange,
}) => {
	const { t } = useTranslation();
	return (
		<div className="time-registration-type-select-wrap">
			<FormControl
				id={id}
				disabled={disabled}
				className="time-registration-type-select"
				as="select"
				value={value}
				onChange={onChange}
			>
				<option value="-1">{t('times.selectType')}</option>
				{options.map((opt) => (
					<option key={opt.id} value={opt.id}>
						{opt.name}
					</option>
				))}
			</FormControl>
		</div>
	);
};

export default TimeRegistrationTypeSelect;
